<template>
  <div class="prod-progress" :class="{ 'prod-progress--compact': compact }">
    <div class="prod-progress__meta">
      <p class="prod-progress__percent">{{ percent }}%</p>
      <p class="prod-progress__caption">
        {{ currentLabel }}
        <span class="prod-progress__stage"> · {{ stepNumber }} of {{ steps.length }}</span>
      </p>
    </div>

    <div class="prod-progress__track" role="progressbar" :aria-valuenow="percent" aria-valuemin="0" aria-valuemax="100">
      <div class="prod-progress__fill" :style="{ width: `${percent}%` }" />
    </div>

    <ol v-if="!compact" class="prod-progress__steps">
      <li v-for="(step, index) in steps" :key="step.value">
        <button
          type="button"
          class="prod-progress__step"
          :class="{
            'is-done': index < currentIndex,
            'is-current': index === currentIndex,
            'is-interactive': interactive
          }"
          :disabled="!interactive"
          :aria-current="index === currentIndex ? 'step' : undefined"
          @click="onSelect(step.value)"
        >
          <span class="prod-progress__dot">
            <span v-if="index < currentIndex" class="material-icons">check</span>
            <span v-else>{{ index + 1 }}</span>
          </span>
          <span class="prod-progress__label">
            <span class="prod-progress__label-full">{{ step.label }}</span>
            <span class="prod-progress__label-short">{{ step.short }}</span>
          </span>
        </button>
      </li>
    </ol>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import { computed } from 'vue'
import {
  productionProgressIndex,
  productionProgressPercent,
  productionProgressSteps,
  productionStatusLabels
} from '../../config/productionNavigation'

const props = defineProps({
  status: {
    type: String,
    default: 'planning'
  },
  compact: {
    type: Boolean,
    default: false
  },
  interactive: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['select'])

const steps = productionProgressSteps
const currentIndex = computed(() => productionProgressIndex(props.status))
const percent = computed(() => productionProgressPercent(props.status))
const stepNumber = computed(() => currentIndex.value + 1)
const currentLabel = computed(() => productionStatusLabels[props.status] || 'Planning')

function onSelect (status) {
  if (!props.interactive || status === props.status) return
  emit('select', status)
}
</script>
